import React from 'react'
import { Alert, Text } from '@mantine/core'
import { IconInfoCircle } from '@tabler/icons-react'
import { useTheme } from '../../../components/ThemeProvider'

const DataDisclaimer: React.FC = () => {
  const theme = useTheme()

  return (
    <Alert
      icon={<IconInfoCircle size={16} />}
      title="数据说明"
      color={theme?.primaryColor}
      variant="light"
      style={{ marginBottom: '16px' }}
    >
      <Text size="sm">
        本关联企业信息基于用户姓名匹配算法获取，可能存在以下情况：同名不同人的误匹配情况；部分真实关联企业可能未被识别；关联关系的准确性需要进一步核实。
      </Text>
    </Alert>
  )
}

export default DataDisclaimer
